import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import type { TeamMember } from '../api/teamApi';
import { MemberRow } from './MemberRow';

type MembersListProps = {
    members: TeamMember[];
    currentUserEmail: string | undefined;
    onRemove: (member: TeamMember) => void;
};

export function MembersList({ members, currentUserEmail, onRemove }: MembersListProps): ReactElement {
    const { t } = useTranslation();

    if (members.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                {t('SETTINGS.MEMBERS.EMPTY')}
            </Typography>
        );
    }

    const normalizedCurrentEmail = currentUserEmail?.toLowerCase();
    const isSelf = (member: TeamMember): boolean => member.email.toLowerCase() === normalizedCurrentEmail;

    const ordered = [...members.filter(isSelf), ...members.filter((member) => !isSelf(member))];

    return (
        <Stack component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
            {ordered.map((member) => (
                <MemberRow key={member.uuid} member={member} isSelf={isSelf(member)} onRemove={onRemove} />
            ))}
        </Stack>
    );
}
